// SEND-245 (Howard ruled 2026-08-14) — JUMP-TO-STEP LINKS.
//
// "After the walk, the bottom row is no longer a pile of chips. Each name is
// a link into that walk section." Click SIDING and the siding walk opens —
// product, exposure, Standard / Architectural, and the siding marks. Click
// J-CHANNEL and the J walk opens with its product, its size and its marks.
// Same for SOFFIT, openings, starter, fascia, the corners, finish trim and
// SCALE.
//
// STANDARD and ARCHITECTURAL ARE NOT LINKS. They are not walk sections: they
// live INSIDE the siding walk and the soffit walk (and J and finish trim),
// where SEND-240 put them. No tier chip is rendered here.
//
// GABLE, DORMER and COIL ARE NOT ON THIS ROW by his ruling — they are off the
// walk (SEND-233) and they get no link. Their tools and their marks are not
// touched; this row simply does not name them.
//
// THIS FILE DRAWS, MEASURES, STORES AND PRICES NOTHING. It is one link per
// walk step, and the link only asks the editor to OPEN that step: no mark is
// wiped, the walk is not restarted, and the SEND-244 gate is untouched — a
// first tap is still refused until that product carries Standard or
// Architectural.
import React from "react";
import { CornerUpLeft } from "lucide-react";

export const JumpRow = ({ steps, stepIdx, onJump, navBlock }) => (
  <div className="flex flex-wrap gap-1 items-center"
    data-testid="photo-takeoff-jump-row">
    <span className="px-1 text-[9px] font-bold uppercase tracking-widest text-[var(--muted)] flex items-center gap-1"
      data-testid="photo-takeoff-jump-row-label">
      <CornerUpLeft size={10} /> jump to
    </span>
    {steps.map((s, i) => (
      <button key={s.key} type="button" disabled={!!navBlock}
        onClick={() => onJump(s.key)}
        title={navBlock || `open the ${s.title} step — add, edit or re-tap. Nothing you drew is wiped and the walk does not restart`}
        className={`px-2 py-1 text-[10px] font-bold uppercase tracking-wider underline underline-offset-2 disabled:opacity-40 hover:bg-[var(--surface-muted)] ${i === stepIdx ? "text-[var(--ai)]" : "text-[var(--ink-2)]"}`}
        data-testid={`photo-takeoff-jump-${s.key}`}>
        {s.title}
      </button>
    ))}
    <span className="px-1 text-[9px] text-[var(--muted)] leading-snug"
      data-testid="photo-takeoff-jump-row-note">
      a link opens that step — your marks stay
    </span>
  </div>
);

export default JumpRow;
